import { ICredentials } from 'data/entities/credentials.entity';
import { credentialsDatasource } from 'data/datasources/credentials.datasource';

interface ICredentialsRepository {
    getCredentials(): ICredentials | null;
}

class CredentialsRepository implements ICredentialsRepository {

    public getCredentials(): ICredentials | null {
        return credentialsDatasource.getCredentials();
    }

}

export const credentialsRepository: ICredentialsRepository = new CredentialsRepository();
